import { api } from '../utils/api';

type UpdateBookingParams = {
  reservation_id: number;
  rooms: {
    adults: number;
    childs: { id: number; count: number; code: string }[];
  }[];
  room_type_id: number;
  arrival: string;
  departure: string;
};

export const updateBooking = async (body: UpdateBookingParams) => {
  const url = '/api/v1/reservation/edit/2/';
  const result = await api.post<{
    payment_link: null | string;
    reservation_id: number;
  }>(url, body);
  return result;
};
